import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const Checked = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-.5-5.5 4.796-4.816a.987.987 0 0 0-1.4-1.393l-4.081 4.099-2.128-2.109a.989.989 0 0 0-1.396 1.4l2.713 2.705a.987.987 0 0 0 1.496.113Z"
    />
  </Icon>
);

export default Checked;
